<!-- AUSTIN'S TROPHY ROOM.

     Locked badges are shown greyed rather than hidden. A locked trophy he can
     read is a reason to go and play the mode it belongs to, and that is the
     entire job of this screen. Hiding them turns it into a list of things he
     has already done, which nobody needs. -->
<template>
  <IonPage>
    <AppHeader title="Trophies" />

    <IonContent :fullscreen="true">
      <AppLargeTitle title="Trophies" />

      <div class="ex-total">
        <div>
          <div class="k">Unlocked</div>
          <div class="n tabular">{{ earned.size }} / {{ TROPHIES.length }}</div>
        </div>
        <div class="center">
          <div class="k">Total points</div>
          <div class="n tabular">{{ (profile.totalScore ?? 0).toLocaleString() }}</div>
        </div>
      </div>

      <div class="scoreline">
        <div class="cell">
          <span class="n">{{ stats.runs }}</span><span class="k">Games</span>
        </div>
        <div class="cell">
          <span class="n">{{ stats.totalCorrect }}</span><span class="k">Right</span>
        </div>
        <div class="cell">
          <span class="n">{{ stats.ausBonuses }}</span><span class="k">AUS</span>
        </div>
        <div class="cell">
          <span class="n">{{ profile.dailyStreak ?? 0 }}</span><span class="k">Streak</span>
        </div>
      </div>

      <p class="ex-eyebrow pad">The cabinet</p>

      <div class="trophy-grid">
        <div
          v-for="t in TROPHIES"
          :key="t.id"
          class="trophy"
          :class="{ locked: !earned.has(t.id) }"
        >
          <span class="badge" aria-hidden="true">{{ t.icon }}</span>
          <span class="name">{{ t.name }}</span>
          <span class="how">{{ t.description }}</span>
          <span v-if="earned.has(t.id)" class="how" style="color: var(--ex-green); font-weight: 800">
            Unlocked
          </span>
          <span v-else class="sr-only">Locked</span>
        </div>
      </div>

      <div class="tail" />
    </IonContent>
  </IonPage>
</template>

<script setup>
import { computed, onMounted } from 'vue';
import { IonPage, IonContent } from '@ionic/vue';
import { AppHeader, AppLargeTitle } from '../core/ui';
import { TROPHIES, lifetimeStats } from '../game/trophies.js';
import { trophys, runs } from '../store.js';
import { profile, ensureProfile } from '../game/profile.js';

const earned = computed(() => new Set(trophys.value.map((t) => t.criterion)));
const stats = computed(() => lifetimeStats(runs.value));

onMounted(ensureProfile);
</script>
